import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"
import { cn } from "../../../../lib/utils.js"
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../../../ui/collapsible.js"
import {
  SidebarMenuButton,
  SidebarMenuItem as SidebarMenuItemPrimitive,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "../../../ui/sidebar.js"

/**
 * Item de menu colapsável com subitens.
 */
export function SidebarCollapsibleItem({
  item,
  collapsed,
  isMobile,
  sectionOpen,
  hasActiveChild,
  onOpenChange,
  isPathActive,
  onNavigate,
  onActiveMenuChange,
}) {
  const Icon = item.icon

  return (
    <SidebarMenuItemPrimitive>
      <Collapsible
        open={sectionOpen}
        onOpenChange={onOpenChange}
        className="group/collapsible flex w-full flex-col gap-0.5"
      >
        <CollapsibleTrigger asChild>
          <SidebarMenuButton
            isActive={sectionOpen || hasActiveChild}
            tooltip={collapsed && !isMobile ? item.label : undefined}
            className={cn(
              "relative flex h-10 w-full items-center rounded-lg p-0 text-[13px] font-medium text-gray-400 transition-colors hover:!bg-gray-900 hover:!text-white active:!bg-gray-900 active:!text-white data-[active=true]:!bg-gray-800 data-[active=true]:!text-white data-[state=open]:hover:!bg-gray-900 data-[state=open]:hover:!text-white",
              collapsed && !isMobile
                ? "justify-center px-0"
                : "justify-start gap-2.5 px-3",
              (sectionOpen || hasActiveChild) &&
                "border-l-2 border-white bg-gray-800 text-white",
            )}
          >
            <Icon size={20} className="flex-shrink-0" />
            {(!collapsed || isMobile) && (
              <>
                <span className="truncate leading-tight">{item.label}</span>
                <ChevronRight
                  size={16}
                  className="ml-auto flex-shrink-0 transition-transform group-data-[state=open]/collapsible:rotate-90"
                />
              </>
            )}
          </SidebarMenuButton>
        </CollapsibleTrigger>
        {sectionOpen && (!collapsed || isMobile) && (
          <CollapsibleContent>
            <SidebarMenuSub className="mx-0 ml-3 flex min-w-0 translate-x-0 flex-col gap-0.5 border-l border-gray-800 py-0 pl-3 pr-0">
              {item.children.map((child) => {
                const ChildIcon = child.icon
                const isChildActive = isPathActive(child.href)

                return (
                  <SidebarMenuSubItem key={child.id}>
                    <SidebarMenuSubButton
                      asChild
                      isActive={isChildActive}
                      className={cn(
                        "relative flex h-10 w-full items-center rounded-lg px-3 text-[13px] font-medium text-gray-400 transition-colors hover:!bg-gray-900 hover:!text-white active:!bg-gray-900 active:!text-white data-[active=true]:border-l-2 data-[active=true]:border-white data-[active=true]:!bg-gray-800 data-[active=true]:!text-white",
                        ChildIcon && "gap-2.5",
                        isChildActive &&
                          "border-l-2 border-white bg-gray-800 text-white",
                      )}
                    >
                      <Link
                        to={child.href}
                        onClick={() => {
                          onActiveMenuChange(child.id)
                          onNavigate(child.href, child.label)
                        }}
                      >
                        {ChildIcon && (
                          <ChildIcon size={20} className="flex-shrink-0" />
                        )}
                        <span className="truncate leading-tight">
                          {child.label}
                        </span>
                      </Link>
                    </SidebarMenuSubButton>
                  </SidebarMenuSubItem>
                )
              })}
            </SidebarMenuSub>
          </CollapsibleContent>
        )}
      </Collapsible>
    </SidebarMenuItemPrimitive>
  )
}
